import type { ReactNode } from "react";
import { toast as sonnerToast, type ExternalToast } from "sonner";

type LegacyToast = {
  title?: ReactNode;
  description?: ReactNode;
  variant?: "default" | "destructive";
  duration?: number;
  action?: ReactNode;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

const showToast = (props: LegacyToast, id?: string | number) => {
  if (props.open === false && id !== undefined) {
    sonnerToast.dismiss(id);
    return id;
  }

  const message = props.title ?? props.description ?? "";
  const options: ExternalToast = {
    id,
    description: props.title ? props.description : undefined,
    duration: props.duration,
    action: props.action,
    className: props.className,
    onDismiss: () => props.onOpenChange?.(false),
    onAutoClose: () => props.onOpenChange?.(false),
  };

  return props.variant === "destructive"
    ? sonnerToast.error(message, options)
    : sonnerToast(message, options);
};

function toast(initialProps: LegacyToast) {
  let currentProps = initialProps;
  const id = showToast(currentProps);

  return {
    id: String(id),
    dismiss: () => sonnerToast.dismiss(id),
    update: (nextProps: LegacyToast) => {
      currentProps = { ...currentProps, ...nextProps };
      showToast(currentProps, id);
    },
  };
}

function useToast() {
  return {
    toasts: sonnerToast.getToasts(),
    toast,
    dismiss: (toastId?: string) => sonnerToast.dismiss(toastId),
  };
}

export { useToast, toast };
